import React, { Component, Fragment } from "react";
import { Input, Label, Button, GridContainer } from "arv-reactcomponents";
import PropTypes from "prop-types";
import { observer, inject } from "mobx-react";
import { PAYMENTPAGE } from "npmlinks-constants";
import Cvv from "../PaymentWallet/CreditCard/Cvv";
import { validCvvLength } from "./../../utils";
import Event from "../../analytics/eventFactory";
import Analytics from "../../analytics";
import PaymentGateway from "../PaymentGateway";
import SavedCardModal from "./SavedCardModal";
import SavedCardView from "./SavedCardView";

@inject("PaymentStore", "SavedCardStore")
@observer
class PaymentSavedCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cardSelectedFromModal: null,
      isSavedCardModalOpen: false,
      cardCvvError: "",
    };
    this.card = {};
    this.handleSubmit = this.handleSubmit.bind(this);
    this.setSavedCard = this.setSavedCard.bind(this);
    this.onFocus = this.onFocus.bind(this);
    this.selectedSavedCard = this.selectedSavedCard.bind(this);
    this.openSavedCardModal = this.openSavedCardModal.bind(this);
    this.onCloseSavedCardModal = this.onCloseSavedCardModal.bind(this);
  }

  componentDidMount() {
    const { savedCards } = this.savedCards;
    this.props.PaymentStore.unSelectSavedCard();
    if (savedCards.length > 0) {
      Analytics.trackEvent({
        action: Event.action.PAYMENT_CARD_SAVE,
        category: window.pageType,
      });
      this.card = savedCards.find(scard => scard.isDefault) || {};
    }
  }

  handleSubmit(cvvData) {
    this.props.SavedCardStore.setSavedCardCvv(cvvData);
    const { cardCvvError, isValid } = cvvData;
    if (!isValid) {
      this.setState({
        cardCvvError:
          cardCvvError || PAYMENTPAGE.CARD_VALIDATION_MESSAGES.CVV_MISSING,
      });
    } else {
      this.setState({
        cardCvvError: "",
      });
    }
  }
  setSavedCard(card) {
    this.props.PaymentStore.selectSavedCard();
    this.props.SavedCardStore.setSelectedSavedCardToken(card);
  }

  selectedSavedCard(card) {
    this.setState({ cardSelectedFromModal: card, isSavedCardModalOpen: false });
  }

  openSavedCardModal() {
    this.setState({ isSavedCardModalOpen: true });
  }

  onCloseSavedCardModal() {
    this.setState({ isSavedCardModalOpen: false });
  }

  onFocus() {
    this.setSavedCard(this.card);
  }

  get isSavedCardSelected() {
    return this.props.PaymentStore.isSavedCardSelected;
  }
  get isSavedCardOpen() {
    return this.props.PaymentStore.isSavedCardOpen;
  }

  get savedCards() {
    return this.props.SavedCardStore;
  }

  get showDefaultSavedCard() {
    const { savedCards } = this.savedCards;
    const { cardSelectedFromModal } = this.state;
    const card =
      cardSelectedFromModal ||
      savedCards.find(scard => scard.isDefault) ||
      savedCards[0];
    const isModal = false;
    this.card = card;
    return (
      <GridContainer>
        <SavedCardView.component
          {...card}
          selectedSavedCard={this.selectedSavedCard}
          handleSubmit={this.handleSubmit}
          onFocus={this.onFocus}
          isModal={isModal}
          isSavedCardSelected={this.isSavedCardSelected}
          optionDisabled={this.props.OptionStatus}
        />
      </GridContainer>
    );
  }

  get getStatus() {
    return this.props.OptionStatus || !this.isSavedCardSelected
      ? "nwc-hide nw-paymentsavedcard-hide"
      : "";
  }

  render() {
    // TODO:: removing this thing later, only for linting purpose
    const { savedCards } = this.savedCards;
    return savedCards && savedCards.length ? (
      <div className={this.props.className}>
        <PaymentGateway.component
          success={this.props.SavedCardStore.successWithUserEnteredCvv}
          componentName="SAVEDCARD"
        />
        <div className="nw-paymentsavedcards-headingwrapper">
          <Input
            className="nwc-inp-radio-primary nw-paymentoption-radio"
            id="paymentsavedcard"
            name="paymentsavedcard"
            type="radio"
            value=""
            disabled={this.props.OptionStatus}
            checked={this.isSavedCardSelected}
            onClick={() => {
              this.setSavedCard(this.card);
            }}
          />
          <Label
            htmlFor="paymentsavedcard"
            className="nw-paymentsavedcard-radiolabel"
          >
            {PAYMENTPAGE.SAVECARD_TITLE}
          </Label>
        </div>
        <div className={this.getStatus}>
          <div className="nw-paymentsavedcards-main">
            {this.showDefaultSavedCard}
          </div>
          {savedCards.length > 1 ? (
            <Button
              className="nwc-btn-primary-txt nw-paymentsavedcards-cardchange"
              onClick={this.openSavedCardModal}
            >
              Change
            </Button>
          ) : null}
        </div>
        <SavedCardModal.component
          isOpen={this.state.isSavedCardModalOpen}
          onClose={this.onCloseSavedCardModal}
          data={savedCards}
          selectedSavedCard={this.selectedSavedCard}
        />
      </div>
    ) : null;
  }
}

PaymentSavedCard.wrappedComponent.defaultProps = {
  className: "",
};

PaymentSavedCard.wrappedComponent.propTypes = {
  PaymentStore: PropTypes.shape({
    paymentOptionsSelection: PropTypes.shape({
      SAVEDCARD: PropTypes.bool.isRequired,
    }).isRequired,
    isSavedCardSelected: PropTypes.bool.isRequired,
    resetPaymentOptions: PropTypes.func.isRequired,
    togglePaymentOptions: PropTypes.func.isRequired,
    toggleSavedCardOpen: PropTypes.func,
    toggleSavedCard: PropTypes.func.isRequired,
    selectSavedCard: PropTypes.func.isRequired,
    isSavedCardOpen: PropTypes.func,
  }).isRequired,
  SavedCardStore: PropTypes.shape({
    savedCards: PropTypes.shape({}).isRequired,
    setSavedCardCvv: PropTypes.func.isRequired,
    setSelectedSavedCardToken: PropTypes.func.isRequired,
    selectedSavedCardToken: PropTypes.string.isRequired,
    successWithUserEnteredCvv: PropTypes.shape({}).isRequired,
  }).isRequired,
  className: PropTypes.string,
  isLoyalty: PropTypes.bool.isRequired,
  OptionStatus: PropTypes.bool.isRequired,
};

const getFinalComponent = component =>
  inject("PaymentStore", "SavedCardStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: PaymentSavedCard.wrappedComponent,
  component: PaymentSavedCard,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/PaymentSavedCard/index.js